export const INBOX_PERMISSION_IDS = ['channels'] as const;

export function hasInboxAccess(
  menuPermissions: string[] | null | undefined,
): boolean {
  if (!Array.isArray(menuPermissions)) return true;
  return INBOX_PERMISSION_IDS.some((id) => menuPermissions.includes(id));
}
